import React from "react";
import Header from "./Header";
import { Helmet } from "react-helmet-async";

const Bonuses = () => {
  const textClass = "md:text-[18px] text-[14px] lg:text-base text-gray-500 text-left poppins-font2 leading-relaxed";

  return (
    <div>
      <Helmet>
        <title>Maximize Your Wins with Slot Bonuses | Fusion Spin</title>
        <meta name="description" content="Discover the best slot bonuses to boost your gameplay with Fusion Spin. Unlock free spins, multipliers, and more!" />
        <meta name="keywords" content="slot bonuses, free spins, slot multipliers, bonus features, casino game rewards, Fusion Spin" />
      </Helmet>

      <Header />

      <section className="bg-white py-10 px-6 md:px-12 lg:px-16 xl:px-20 2xl:px-0 mx-auto max-w-screen-xl">
        <div className="text-center lg:text-start">
          <h1 className="text-2xl md:text-3xl pb-4 lg:text-[2.5rem] font-bold text-black poppins-font tracking-wider">
            <span className="poppins-font">Discover Exciting Bonus Features on Modern Slot Machines</span>
          </h1>
          <hr className="w-14 bg-black h-[2px] border-none shadow-lg mb-7 hidden sm:block" />
        </div>

        <div className={textClass}>
          <p className={`${textClass} m-0`}>
            At Fusion Spin, we know that bonus games are more than just a feature—they’re an essential part of what makes modern slot machines thrilling and memorable. These interactive bonus rounds break the routine of standard spinning reels, adding excitement, engagement, and the potential for bigger wins.
          </p>

          <p className={`${textClass} m-0 mt-4`}>
            Our slot machines are designed to captivate players with visually appealing designs, immersive sound effects, and unique gameplay mechanics.
          </p>

          <h2 className="text-xl md:text-2xl pb-4 pt-4 lg:text-[1.5rem] font-bold text-gray-00 poppins-font tracking-wider">
            <span className="poppins-font text-gray-900">Popular Slot Machine Bonus Features:</span>
          </h2>

          <ul className="list-disc pl-6 md:pl-8 space-y-3">
            {[
              {
                title: "Pick & Choose",
                desc: "Players choose from hidden icons to uncover exciting rewards like cash prizes, free spins, or multipliers—introducing an element of strategy and engagement to the gameplay."
              },
              {
                title: "Bonus Wheel",
                desc: "Give the colorful, segmented wheel a spin and watch as exciting prizes come into view. The suspense intensifies as the wheel gradually comes to a stop, adding thrill to every spin."
              },
              {
                title: "Multiple Level Bonus Rounds",
                desc: "Progress through various stages of the game, unlocking increasingly valuable rewards as you advance. Each level brings a new challenge and greater excitement."
              },
              {
                title: "Mini Games Bonus Rounds",
                desc: "Step into engaging mini-games that add a fresh twist to the slot experience. These rounds combine interactive elements with rewarding outcomes, offering substantial payouts."
              }
            ].map((item, index) => (
              <li key={index} className={textClass}>
                <strong className="font-bold">{item.title}:</strong> {item.desc}
              </li>
            ))}
          </ul>

          <p className={`${textClass} m-0 pt-4 pb-8`}>
            With over 50 different bonus game features, we ensure endless variety and excitement tailored to captivate every player’s imagination.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Bonuses;
